import styled from "styled-components";

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Title = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 26px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
  white-space: nowrap;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
export const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;
export const Link = styled.span`
  font-family: Figtree;
  color: #b3d4ff;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  cursor: pointer;
  text-decoration-line: underline;
`;

export const Description = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  max-width: 715px;
  font-weight: 400;
  line-height: 25px; /* 166.667% */
`;

export const Text = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: ${(props) => (props.$bold ? "800" : "500")};
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.08px;
  text-decoration: ${(props) => (props.$link ? "underline" : "none")};
  cursor: ${(props) => (props.$link ? "pointer" : "default")};
  &:hover {
    opacity: ${(props) => (props.$link ? ".85" : "1")};
  }
`;

export const TemplatesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const EmptyStateCard = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
`;

export const TemplateRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  flex-wrap: wrap;
  gap: 16px;

  border-bottom: ${(props) => (props.$isLast ? "none" : "1px solid #142743")};
  padding-bottom: 16px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileTemplateRow = styled.div`
  display: none;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;

  border-bottom: ${(props) => (props.$isLast ? "none" : "1px solid #142743")};
  padding-bottom: 16px;

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const TemplateColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: ${(p) => p.$alignItems || "flex-start"};
  gap: ${(p) => p.$gap || 0};
`;

export const TemplateLabel = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.5;
  letter-spacing: -0.21px;
`;

export const TemplateValue = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const TemplateFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const BalanceSection = styled.div`
  border-radius: 20px;
  border: 1px solid #142743;
  background: #0b1727;
  padding: 16px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  padding: 24px 0;
  padding-top: 0;
  flex: 1;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: -8px;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const MobileTextContainer = styled.div`
  display: none;
  flex-direction: column;
  gap: 12px;
  margin-top: -8px;
  @media (max-width: 768px) {
    display: flex;
  }
`;

export const SmallTitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 17px;
  font-weight: 600;
`;
export const SmallRow = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const SmallTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  justify-content: space-between;

  width: 100%;
  margin-top: 18px;
`;

export const BalanceContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;

export const BalanceDollar = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  opacity: 0.8;
`;

export const Balance = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 24px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  border-radius: 20px;
  background: #0b1727;
  flex: 1;
  padding-bottom: 12px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: row;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;

  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  background: #142743;
`;

export const CardHeaderColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CardHeaderTitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 17px;
  font-weight: 600;
`;

export const CardHeaderSubtitle = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  opacity: 0.6;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const CardTextRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 16px;
  opacity: ${(p) => (p.$light ? 0.8 : 1)};
  width: 100%;
`;

export const CardText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: ${(p) => (p.$light ? 400 : 600)};
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.42px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  gap: 4px;
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 16px;
`;

// New styled component for section header with chevron
export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 16px;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.8;
  }

  ${SectionTitle} {
    margin-bottom: 0;
  }
`;

// New styled component for table container with animation
export const TableContainer = styled.div`
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: ${({ $isExpanded }) => ($isExpanded ? "609px" : "0px")};
  opacity: ${({ $isExpanded }) => ($isExpanded ? 1 : 0)};
  transform: ${({ $isExpanded }) =>
    $isExpanded ? "translateY(0)" : "translateY(-20px)"};
  margin-bottom: ${({ $isExpanded }) => ($isExpanded ? "0" : "-16px")};

  /* Additional smooth animation for the inner content */
  ${({ $isExpanded }) =>
    !$isExpanded &&
    `
    pointer-events: none;
  `}

  overflow-x: auto;

  &::-webkit-scrollbar {
    width: 0px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #2877d9;
    border-radius: 100px;
  }
`;

export const Table = styled.table`
  width: 100%;
  min-width: 700px;
  border-radius: 8px;
  overflow: hidden;
  border-spacing: 0 12px;
`;

export const TableRow = styled.tr`
  &:last-child {
    border-bottom: none;
  }
`;

export const TableHeader = styled.th`
  text-align: left;
  color: #fff;
  padding-bottom: 12px;
  font-weight: 400;
  font-size: 14px;
  opacity: 0.4;
  &:last-child {
    text-align: right;
  }
`;

export const TableCell = styled.td`
  padding: ${({ $isFirst }) => ($isFirst ? "6px 8px" : "6px 0px")};
  font-weight: 400;
  color: #fff;
  font-size: 14px;
  border-bottom: 1px solid #2c4a76;
  text-transform: capitalize;
  &:last-child {
    text-align: right;
  }
`;

export const TimeAgoCell = styled(TableCell)`
  position: relative;
  cursor: help;
`;
export const Relative = styled.div`
  position: relative;
  cursor: help;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
export const TableLoading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
`;
export const Tooltip = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  /* transform: translateX(-46%); */
  background: rgba(255, 255, 255, 0.95);
  color: #1a1a1a;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  opacity: ${({ $show }) => ($show ? "1" : "0")};
  visibility: ${({ $show }) => ($show ? "visible" : "hidden")};
  transition: all 0.2s ease;
  pointer-events: none;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 250px;

  /* &::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: rgba(255, 255, 255, 0.95);
  } */
`;
export const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 700px;
`;

export const FooterText = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
`;

export const Pagination = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const PaginationButton = styled.button`
  background: none;
  border: none;
  color: ${(props) =>
    props.$disabled ? "rgba(255,255,255,0.3)" : "rgba(255,255,255,0.7)"};
  font-size: 14px;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  transition: color 0.3s ease;

  &:hover:not(:disabled) {
    color: #fff;
  }
`;

export const PaginationCurrent = styled.span`
  color: #fff;
  font-size: 14px;
`;

export const FooterActions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
  padding: 28px 20px 60px 20px;
  text-align: center;
  flex: 1;

  h3 {
    font-size: 24px;
    margin-bottom: 12px;
    font-family: Figtree;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    max-width: 400px;
    font-family: Figtree;

    opacity: 0.6;
    margin-bottom: 24px;
  }
`;

export const NotLoggedInContainer = styled.div`
  margin-top: 48px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 1440px;
  padding: 0px 16px;
  padding-bottom: 81px;
`;

export const LoginButton = styled.button`
  display: flex;
  width: ${(props) => (props.$width ? "100%" : "180px")};
  height: 40px;
  padding: 12px 44px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const NoWrapText = styled.span`
  white-space: nowrap;
`;

export const DescriptionText = styled.span`
  color: white;
  font-family: Figtree;
  font-size: 13px;
  opacity: 0.5;
  font-weight: 300;
`;
